import { createToaster } from "@meforma/vue-toaster";
const toast = createToaster({ position: "top-right", duration: 3000 });

export function toastDispatch(result, type) {
  if (type === "success") {
    toast.success(`${result.data.message}`);
  } else if (type === "error") {
    if (result.response.data.error) {
      toast.error(`${result.response.data.error}`);
    } else {
      toast.error(`${result.response.data.message}`);
    }
  }
}
